import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import useInView from "../../hooks/useInView";

export default function AwardsSection() {
  const [ref, isInView] = useInView();
  const [awardCount, setAwardCount] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    if (!isInView) return;
    let start = 0;
    const end = 200;
    const duration = 2500;
    const increment = end / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setAwardCount(end);
        clearInterval(timer);
      } else {
        setAwardCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [isInView]);

  const quotes = [
    {
      label: "Someone at Karada House saying:",
      text: "”I’ve never felt this safe in a space before.“",
      href: "/work/karada-house",
    },
    {
      label: "An email after ’The Artist & The Pervert‘:",
      textDesktop: (
        <>
          ”I watched it with my partner.<br />Then we talked about it all night.“
        </>
      ),
      textMobile: "”I watched it with my partner. Then we talked about it all night.“",
      href: "/work/the-artist-and-the-pervert",
    },
    {
      label: "An agency producer:",
      text: "”This will never work.“ And yet, it did.",
      href: "/work/bombs-from-berlin",
    },
  ];

  const ArrowRight = () => (
    <svg
      width="27"
      height="30"
      viewBox="0 0 177.38 194.19"
      style={{ transform: "rotate(-90deg)", display: "block" }}
    >
      <line
        stroke="currentColor"
        strokeWidth="30"
        strokeMiterlimit="10"
        fill="none"
        x1="88.69"
        x2="88.69"
        y2="166.1"
      />
      <polyline
        stroke="currentColor"
        strokeWidth="30"
        strokeMiterlimit="10"
        fill="none"
        points="12.73 91.62 89.84 168.73 164.65 93.92"
      />
    </svg>
  );

  return (
    <section
      id="awards"
      ref={ref}
      className="bg-black"
      style={{ padding: isMobile ? "50px 10px 75px" : "50px 48px 150px" }}
    >
      <div
        style={{
          maxWidth: "1024px",
          margin: isMobile ? "10px" : "0 auto",
          textAlign: "center",
          transform: isMobile ? "rotate(0deg)" : "rotate(-1.5deg)",
        }}
      >
        <h2 className="heading-section" style={{ marginBottom: 0 }}>
          <span
            style={{
              display: "block",
              opacity: isInView ? 1 : 0,
              filter: `blur(${isInView ? 0 : 10}px)`,
              transform: `translateY(${isInView ? 0 : -20}px)`,
              transition: "opacity 0.8s ease-out 0.5s",
            }}
          >
            AWARDS DON’T
          </span>
          <span
            style={{
              display: "block",
              opacity: isInView ? 1 : 0,
              filter: `blur(${isInView ? 0 : 10}px)`,
              transform: `translateY(${isInView ? 0 : -20}px)`,
              transition: "opacity 0.8s ease-out 0.65s",
            }}
          >
            MEAN SHIT
          </span>
        </h2>
        <p
          style={{
            marginTop: "10px",
            marginBottom: "56px",
            color: "#71717a",
            textTransform: "uppercase",
            fontFamily: "Archivo, sans-serif",
            fontVariationSettings: '"wdth" 80, "wght" 750',
            fontSize: "clamp(24px, 3vw + 10px, 48px)",
            opacity: isInView ? 1 : 0,
            lineHeight: "0.95",
            transition: "opacity 0.8s ease-out 0.8s",
          }}
        >
          <strong>But they opened doors</strong>
        </p>
        <div className="body-medium">
          <p>
            {isMobile ? (
              "10 Cannes Lions. Red Dot Grand Prix. ADC Gold. One Show Gold. Film festival wins from Berlin to New York. Also: ’Flop of the Week‘ in W&V."
            ) : (
              <>
                10 Cannes Lions. Red Dot Grand Prix. ADC Gold. One Show Gold.
                <br />
                Film festival wins from Berlin to New York.
                <br />
                Also: ’Flop of the Week‘ in W&V.
              </>
            )}
          </p>
          <h3
            style={{
              color: "#fff",
              fontSize: "24px",
              paddingTop: "12px",
              fontWeight: "bold",
              marginTop: "24px",
            }}
          >
            What I actually remember:
          </h3>
          <div
            style={{
              padding: "16px 0",
              maxWidth: "800px",
              margin: "16px auto",
            }}
          >
            {quotes.map((quote, idx) => (
              <div
                key={idx}
                style={{ marginBottom: idx < quotes.length - 1 ? "32px" : 0 }}
              >
                <p
                  style={{
                    color: "#71717a",
                    fontSize: "16px",
                    marginBottom: "4px",
                  }}
                >
                  {quote.label}
                </p>
                <p className="text-quote">
                  {!isMobile && quote.textDesktop
                    ? quote.textDesktop
                    : quote.textMobile ?? quote.text}
                </p>
                <Link
                  to={quote.href}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    marginTop: "8px",
                    textDecoration: "none",
                    color: "#71717a",
                    transition: "color 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = "#fff";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = "#71717a";
                  }}
                >
                  <ArrowRight />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}